import {
  CREATE_FORM_ELEMENTS,
  ADD_MARKETING_ELEMENT,
  UPDATE_FORM,
  UNSET,
  SUBMIT_REQUEST,
  SUBMIT_SUCCESS,
  SUBMIT_FAILURE,
  SHOW_LOADER,
  VALID,
  INVALID,
  SHOW_ERROR,
  SHOW_FORM,
  SHOW_SUCCESS,
  SET_SHOW_USER_ERRORS,
  OPTIN,
  DEFAULT_CUSTOMER_TYPE,
  MARKETING_CONSENT,
  MARKETING_CONSENT_POST,
  MARKETING_CONSENT_EMAIL,
  SET_REQUIRE_ADDRESS,
  ADDRESS_FINDER,
  SET_GOOGLE_ADDRESS_IS_OPEN,
  UPDATE_FORM_ERRORS
} from './constants'
import { fireSubmitIsASucess, fireSubmitFailed } from 'form/services'
import { submitForm } from 'services'

export const SubmitRequest = () => ({
  type: SUBMIT_REQUEST
})

export const SubmitSuccess = payload => ({
  type: SUBMIT_SUCCESS,
  payload
})

export const SubmitFailure = error => ({
  type: SUBMIT_FAILURE,
  error
})

export const ShowForm = payload => ({
  type: SHOW_FORM,
  payload
})
export const ShowError = payload => ({
  type: SHOW_ERROR,
  payload
})
export const ShowSuccess = payload => ({
  type: SHOW_SUCCESS,
  payload
})

export const ShowLoader = payload => ({
  type: SHOW_LOADER,
  payload
})

const isGoogleAddress = (
  item,
  googleAddressFields,
  googleAddressFieldsParamKeys
) => {
  for (let i = 0; i < googleAddressFields.length; i++) {
    if (googleAddressFields[i] === item) {
      return { google: true, key: googleAddressFieldsParamKeys[item] }
    }
  }
  return { google: false, key: item }
}

const convertForParameter = (
  item,
  formData,
  googleAddressIsNeeded,
  googleAddressFields,
  googleAddressFieldsParamKeys
) => {
  const isAddressItem = isGoogleAddress(
    item,
    googleAddressFields,
    googleAddressFieldsParamKeys
  )

  if (item === ADDRESS_FINDER) {
    // its a google ADDRESS_FINDER, which we DONT sent to the api
    return {
      include: false
    }
  } else if (isAYesNoMarketingConsentGroup(item)) {
    // its a marketing radio item, we need to rename the key!
    if (valueIsEqualToNo(formData[item])) {
      return {
        include: false
      }
    }
    return {
      key: MARKETING_CONSENT,
      value: formData[item].value,
      include: true
    }
  } else if (isAddressItem.google) {
    // its a google address item, we need to rename the key!
    if (googleAddressIsNeeded) {
      return {
        key: isAddressItem.key,
        value: formData[item].value,
        include: true
      }
    }
    return {
      include: false
    }
  } else if (item === OPTIN) {
    return {
      key: formData[item].value,
      value: 'true',
      include: true
    }
  } else if (formData[item].valid === VALID) {
    // its any other item, we can return as is
    return {
      key: item,
      value: formData[item].value,
      include: true
    }
  }
  // fallback
  return {
    include: false
  }
}

const createPostParameters = (
  vehicleId,
  campaignCode,
  formData,
  googleAddressIsNeeded,
  googleAddressFields,
  googleAddressFieldsParamKeys
) => {
  const params = new URLSearchParams()
  // Don't send the global vehicleId if its part of the formData and if it's mandatory
  if (formData.vehicleId) {
    if (!formData.vehicleId.value) {
      params.append('vehicleId', vehicleId)
    }
  } else {
    params.append('vehicleId', vehicleId)
  }
  params.append('campaignCode', campaignCode)

  Object.keys(formData).forEach(item => {
    const param = convertForParameter(
      item,
      formData,
      googleAddressIsNeeded,
      googleAddressFields,
      googleAddressFieldsParamKeys
    )
    if (param.include) {
      params.append(param.key, param.value)
    }
  })

  return params.toString()
}

const showSubmitFailed = (
  errorMessage,
  error,
  vehicleId,
  vehicleLabel,
  dispatch
) => {
  fireSubmitFailed(errorMessage, vehicleId, vehicleLabel)
  dispatch(SubmitFailure(error))
  dispatch(ShowLoader(false))
  dispatch(ShowError(true))
}

export const sendForm = (
  apis,
  vehicleId,
  vehicleLabel,
  campaignCode,
  formData,
  googleAddressIsNeeded
) => async (dispatch, getState) => {
  const { form } = getState()
  const {
    formData,
    googleAddressIsNeeded,
    googleAddressFields,
    googleAddressFieldsParamKeys
  } = form
  const origin = process.env.REACT_APP_DATA || window.location.origin
  const endpoint = origin + apis.endpoint
  const params = createPostParameters(
    vehicleId,
    campaignCode,
    formData,
    googleAddressIsNeeded,
    googleAddressFields,
    googleAddressFieldsParamKeys
  )
  dispatch(ShowLoader(true))
  dispatch(SubmitRequest())
  submitForm(endpoint, params)
    .then(response => {
      if (response.status === 202) {
        const customerType = formData.customerType
          ? formData.customerType.value
          : DEFAULT_CUSTOMER_TYPE
        const marketingConsent = formData.optin
          ? formData.optin.value.replace('optin', '')
          : 'Email'
        const enquiryType = formData.enquiryType
          ? formData.enquiryType.value
          : null
        fireSubmitIsASucess(
          vehicleId,
          vehicleLabel,
          customerType,
          marketingConsent,
          enquiryType
        )
        dispatch(SubmitSuccess(response))
        dispatch(ShowForm(false))
        dispatch(ShowLoader(false))
        dispatch(ShowSuccess(true))
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      } else {
        const message =
          response.data && response.data.errors
            ? response.data.errors
            : 'server error'
        showSubmitFailed(message, response, vehicleId, vehicleLabel, dispatch)
      }
    })
    .catch(error => {
      showSubmitFailed('server error', error, vehicleId, vehicleLabel, dispatch)
    })
}

export const createFormElements = fields => (dispatch, getState) => {
  const { form } = getState()
  const googleParamKeyes = []
  googleParamKeyes['street_number'] = 'houseNumber'
  googleParamKeyes['route'] = 'address'
  googleParamKeyes['postal_town'] = 'town'
  googleParamKeyes['administrative_area_level_2'] = 'county'
  googleParamKeyes['postal_code'] = 'postcode'

  let {
    formData,
    rows,
    googleAddressFields,
    googleAddressFieldsParamKeys
  } = form
  for (let k = 0; k < fields.length; k++) {
    const currentRow = fields[k]
    const itemsInRow = currentRow.items
    rows.push(currentRow)
    for (let i = 0; i < itemsInRow.length; i++) {
      const item = itemsInRow[i]
      if (item.name.indexOf('marketingConsent') >= 0) {
        dispatch(addMarketingElement(item))
      }
      if (item.name.indexOf('text') !== 0) {
        if (item.name === ADDRESS_FINDER) {
          for (let j = 0; j < item.addressFields.length; j++) {
            const k = item.addressFields[j].name
            formData[k] = {
              value: '',
              valid: UNSET,
              required: item.addressFields[j].required
            }
            googleAddressFields.push(k)
            googleAddressFieldsParamKeys[k] = googleParamKeyes[k]
          }
          formData[item.addressField.name] = {
            value: '',
            valid: VALID,
            required: item.addressField.required
          }
        } else {
          formData[item.name] = {
            value: '',
            valid: UNSET,
            required: item.required
          }
        }
      }
    }
  }
  dispatch(createInitalForm(formData))
}

export const setShowUserErrors = payload => ({
  type: SET_SHOW_USER_ERRORS,
  payload
})

/*
We can have 2 types of marketing consent radio groups
1. 'marketingConsent' = this is a regular radio group, where each and every option is regraded as a valid choice:

name: 'marketingConsent',
options: [
  {
    label: 'Email',
    value: 'EMAIL'
  },
  {
    label: 'Phone',
    value: 'PHONE'
  }

2. a list of 2 different options: 'marketingConsentEmail', 'marketingConsentPost' = Each is displayed in its own radio group row with YES / NO options
Before we submit these to the API we have to rename all keys back to 'marketingConsent',
thus sending the API a list of the same 'marketingConsent' keys but each with their different selected values

The exception is 'marketingConsentEmail' where a NO value is regarded as an INVALID option, which prevents the
whole form from submitting!

name: 'marketingConsentEmail',
options: [
  {
    label: 'Yes',
    value: 'EMAIL'
  },
  {
    label: 'No',
    value: 'NO'
  }

name: 'marketingConsentPost',
options: [
  {
    label: 'Yes',
    value: 'POST'
  },
  {
    label: 'No',
    value: 'NO'
  }
*/
const isAYesNoMarketingConsentGroup = key => {
  return key !== MARKETING_CONSENT && key.indexOf(MARKETING_CONSENT) >= 0
}

const valueIsEqualToNo = item => {
  return item.value.toLowerCase() === 'no'
}

const didPostChange = (hasMarketingConsentPost, key, obj, dispatch) => {
  if (hasMarketingConsentPost && key === MARKETING_CONSENT_POST) {
    dispatch(setRequirePostalAddress(!valueIsEqualToNo(obj)))
  }
}

export const updateFormErrors = () => (dispatch, getState) => {
  const { form } = getState()
  let {
    formData,
    initialised,
    showUserErrors,
    hasMarketingConsentPost,
    googleAddressIsNeeded,
    googleAddressIsOpen,
    googleAddressFields
  } = form

  if (!initialised) {
    dispatch(updateFormErrorsTo(true))
    return true
  }

  let listToExclude = []
  let needToSetAddressToFalse = false
  let containsErrors = false

  // do we have POST? did user select it? figure out which out of the google fields need to be errored out
  if (hasMarketingConsentPost && googleAddressIsNeeded) {
    if (!googleAddressIsOpen) {
      listToExclude = [...googleAddressFields]
      needToSetAddressToFalse = true
    }
  } else {
    // exclude google address & all its fields
    listToExclude = [...googleAddressFields]
  }

  Object.keys(formData).forEach(field => {
    const item = formData[field]

    if (field === ADDRESS_FINDER) {
      // always make sure ADDRESS_FINDER is set correctly
      // as thats visible all the time!
      // and its red error validation needs to be toggled corectly
      item.valid = needToSetAddressToFalse ? INVALID : VALID
    } else {
      // for all others check the list
      // am i on the exclude list?
      let includeMe = true
      for (let i = 0; i < listToExclude.length; i++) {
        if (listToExclude[i] === field) {
          includeMe = false
          break
        }
      }

      // yes i am included
      if (includeMe) {
        // for all other fields check if its included
        if (item.required && (item.valid === INVALID || item.valid === UNSET)) {
          containsErrors = true
        } else if (item.originalValid && item.originalValid !== item.valid) {
          // we need to make sure previously overwriden validations is undone here!
          item.valid = item.originalValid
          delete item.originalValid
        }
      } else {
        // even though i am excluded, I might be visible
        // therefore my red error validation might require switching off!
        // if it does, rememeber the origial validation, so it can be undone when i'm toggle into the include list
        if (item.valid === INVALID || item.valid === UNSET) {
          item.originalValid = item.valid
          item.valid = VALID
        }
      }
    }
  })
  dispatch(updateFormErrorsTo(containsErrors))
  if (showUserErrors && !containsErrors) {
    dispatch(setShowUserErrors(false))
  }

  return containsErrors
}

const updateFormErrorsTo = payload => ({
  type: UPDATE_FORM_ERRORS,
  payload
})

export const setFormElement = (key, obj) => (dispatch, getState) => {
  const { form } = getState()
  let { formData, marketingConsentElements, hasMarketingConsentPost } = form

  if (isAYesNoMarketingConsentGroup(key)) {
    let valid = obj.valid
    let hasMarketingConsentBeenGiven = false

    // work out if this is a marketing consent item
    // even if the user selected NO, we can treat this as VALID
    // as long as another marketing consent item is valid
    if (valueIsEqualToNo(obj)) {
      for (let i = 0; i < marketingConsentElements.length; i++) {
        const item = marketingConsentElements[i]
        if (item.name !== key && !valueIsEqualToNo(formData[item.name])) {
          hasMarketingConsentBeenGiven = true
          break
        }
      }

      valid = VALID
      // MARKETING_CONSENT_EMAIL cannot be set to NO!
      if (key === MARKETING_CONSENT_EMAIL || !hasMarketingConsentBeenGiven) {
        valid = INVALID
        dispatch(setShowUserErrors(true))
      }
    } else {
      if (key === MARKETING_CONSENT_POST) {
        dispatch(setShowUserErrors(true))
      }
      // there might be case where we currently got an invalid red error
      // on another marketing consent item
      // is needs to now be set to VALID, as hasMarketingConsentBeenGiven
      for (let i = 0; i < marketingConsentElements.length; i++) {
        const item = marketingConsentElements[i]
        if (
          item.name !== key &&
          formData[item.name].valid === INVALID &&
          item.name !== MARKETING_CONSENT_EMAIL
        ) {
          formData[item.name].valid = VALID
          didPostChange(
            hasMarketingConsentPost,
            item.name,
            formData[item.name],
            dispatch
          )
        }
      }
    }
    obj.valid = valid
    didPostChange(hasMarketingConsentPost, key, obj, dispatch)
  }

  obj.required = formData[key].required
  formData = { ...formData, [key]: obj }
  dispatch(updateForm(formData))
}

const createInitalForm = payload => ({
  type: CREATE_FORM_ELEMENTS,
  payload
})

export const setGoogleAddressIsOpenTo = payload => ({
  type: SET_GOOGLE_ADDRESS_IS_OPEN,
  payload
})

const addMarketingElement = payload => ({
  type: ADD_MARKETING_ELEMENT,
  payload
})

const setRequirePostalAddress = payload => ({
  type: SET_REQUIRE_ADDRESS,
  payload
})

export const updateForm = payload => (dispatch, getState) => {
  const { form } = getState()
  let { showUserErrors } = form

  dispatch(updateFormNow(payload))

  if (showUserErrors) {
    dispatch(updateFormErrors())
  }
}

const updateFormNow = payload => ({
  type: UPDATE_FORM,
  payload
})
